import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Policy } from 'components/elements/policy/Policy';
import { Input } from 'components/forms/input/Input';
import { openTextModal, openThanks } from 'features/common/common.slice';
import { FormEventHandler } from 'react';
import {
  clearRating,
  selectRating,
  setRatingName,
  setRatingPhone,
  toggleRatingPolicy,
} from './rating.slice';
import styles from './rating.module.scss';

declare const ym: any;
declare const _tmr: any;
// declare const gtag: any;

export const Rating = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const rating = useAppSelector(selectRating);

  const handleSubmit: FormEventHandler<HTMLFormElement> = async (event) => {
    event.preventDefault();

    ym(88678071, 'reachGoal', 'kick');
    _tmr.push({ type: 'reachGoal', id: 3733626, goal: 'arrow' });
    // ym(87397023, 'reachGoal', 'kick');
    // gtag('event', 'submit', { event_category: 'form' });

    setTimeout(() => dispatch(openThanks('request')), 300);

    await fetch('/ajax/_forms.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        form: 'Вопрос',
        name: rating.name,
        phone: rating.phone,
      }),
    });

    dispatch(clearRating());
  };

  return (
    <form className={styles.module} onSubmit={handleSubmit}>
      <Input
        className={styles.name}
        placeholder="Имя"
        value={rating.name}
        onChange={(event) => dispatch(setRatingName(event.target.value))}
      />

      <Input
        className={styles.phone}
        placeholder="Телефон"
        type="tel"
        pattern="^\+?[0-9()\- ]+"
        required
        value={rating.phone}
        onChange={(event) => dispatch(setRatingPhone(event.target.value))}
      />

      <Policy
        className={styles.policy}
        checked={rating.policyChecked}
        onChange={() => dispatch(toggleRatingPolicy())}
        onClick={() => dispatch(openTextModal('policy'))}
        required
      />

      <button className={styles.button}>Заказать звонок</button>
    </form>
  );
};
